class FsReadMore extends HTMLElement {
  constructor () {
    super()

    this.elButton = this.querySelector('button')
    this.elInitialContent = this.querySelector('.initial-content')
    this.elAdditionalContent = this.querySelector('.additional-content')
    // this.mm = gsap.matchMedia()

    this.elButton.addEventListener('click', () => {
      this.elButton.remove()
      this.elInitialContent.remove()
      this.elAdditionalContent.classList.remove('hidden')
    })
  }
}

if (!customElements.get('fs-read-more')) {
  customElements.define('fs-read-more', FsReadMore)
}
